import React, { useState, useEffect } from 'react';
import { getPhotoStudioAppointments } from '../services/photoStudioService';

const CalendarView = ({ selectedStudio = 'BLR13' }) => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

  const loadAppointments = async () => {
    try {
      const result = await getPhotoStudioAppointments();
      if (result.success) {
        const filtered = result.data.filter(apt => 
          apt.siteCode === selectedStudio && apt.status !== 'Cancelled'
        );
        setAppointments(filtered);
      }
    } catch (error) {
      console.error('Error loading appointments:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Completed': return '#28a745';
      case 'In Progress': return '#007bff';
      case 'Expired': return '#dc3545';
      default: return '#ffc107';
    }
  };

  const getAppointmentsForDate = (date) => {
    return appointments.filter(apt => {
      const aptDate = new Date(apt.submissionDate || apt.createdAt).toDateString();
      return aptDate === new Date(date).toDateString();
    });
  };

  useEffect(() => {
    loadAppointments();
  }, [selectedStudio]);

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '20px' }}>Loading calendar...</div>;
  }

  const dayAppointments = getAppointmentsForDate(selectedDate);

  return (
    <div style={{ padding: '20px' }}>
      <h3>📅 {selectedStudio} Photo Studio Calendar</h3>
      
      <div style={{ marginBottom: '20px' }}>
        <label>Select Date: </label>
        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          style={{ padding: '8px', marginLeft: '10px' }}
        />
      </div>

      <div style={{ 
        border: '1px solid #ddd', 
        borderRadius: '8px', 
        padding: '20px',
        backgroundColor: '#f9f9f9'
      }}>
        <h4>Appointments for {new Date(selectedDate).toLocaleDateString()}</h4>
        
        {dayAppointments.length === 0 ? (
          <p style={{ color: '#666', fontStyle: 'italic' }}>No appointments for this date</p>
        ) : (
          <div style={{ display: 'grid', gap: '10px' }}>
            {dayAppointments.map(apt => (
              <div key={apt.id} style={{
                padding: '15px',
                backgroundColor: 'white',
                border: `3px solid ${getStatusColor(apt.status)}`,
                borderRadius: '6px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <div>
                  <strong>{apt.tokenNumber}</strong> - {apt.email?.split('@')[0]}
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    Time: {apt.estimatedTime?.split('|')[0] || 'N/A'} | 
                    Position: #{apt.queuePosition}
                  </div>
                </div>
                <div style={{
                  padding: '4px 8px',
                  backgroundColor: getStatusColor(apt.status),
                  color: 'white',
                  borderRadius: '4px',
                  fontSize: '12px',
                  fontWeight: 'bold'
                }}>
                  {apt.status}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarView;